import {MutationTree} from "vuex";
import RecruitmentSource from '../ts/RecruitmentSourceInterface';
import * as moment from 'moment';

export const mutations: MutationTree<any> = {

    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setData(state: any, payload: Array<RecruitmentSource>) {
        state.recruitmentSources = payload;
        state.expires = moment().add(15, 'minutes');
    },

    delete(state: any, id: number) {

        let index = state.recruitmentSources.findIndex( (source: RecruitmentSource) => {

            return source.id == id;
        });

        state.recruitmentSources.splice(index, 1);
    },

    create(state: any, recruitmentSource: RecruitmentSource) {

        state.recruitmentSources.push(recruitmentSource);
    },

    update(state: any, recruitmentSource: RecruitmentSource) {

        let foundSource = state.recruitmentSources.find( (source: RecruitmentSource) => {

            return source.id === recruitmentSource.id;
        });

        foundSource = Object.assign(foundSource,recruitmentSource);
    },
};
